<template>
  <v-autocomplete
    color="primary"
    v-model="materialsSelected"
    :clearable="!unclearable"
    :items="materialsItems"
    :loading="materialsLoading"
    :search-input.sync="materialsSearch"
    item-text="Description"
    item-value="material_id"
    item-disabled="disabled"
    :label="noLabel ? '' : $t('Material.title')"
    return-object
    autofocus
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    :no-data-text="
      settings.material_count >= materialCountMax
        ? $t('MaterialTemplate.DetailHint')
        : this.materialsLoading
        ? $t('MaterialTemplate.loadingText')
        : $t('$vuetify.noDataText')
    "
    v-on:keyup.enter="enterToGetMaterial()"
    :hint="
      settings.material_count >= materialCountMax
        ? $t('MaterialTemplate.DetailHint')
        : ''
    "
    persistent-hint
  >
    <template v-slot:item="{ item }">
      <v-row no-gutters style="height: 60px">
        <v-col v-if="item.combineFlg" cols="12" sm="6" md="7">
          <v-icon x-small class="pe-1">fa-box</v-icon>
          {{ item.material_name }}
          <span
            v-for="(detail, index) in item.details"
            :key="index"
            class="subtitle-2 secondary--text"
          >
            {{ index == 0 ? "(" : "" }}{{ detail.material_name }}x{{
              detail.combine_num
            }}{{ index != item.details.length - 1 ? "," : ")" }}
          </span>
        </v-col>
        <v-col v-else cols="12" sm="6" md="7">
          <v-chip
            color="blue lighten-1"
            label
            x-small
            text-color="white"
            v-if="item.campaign"
            style="-webkit-transform: scale(0.7); -webkit-transform-origin: 0 0"
          >
            <span>
              {{ item.campaign ? item.campaign.name : "" }}
            </span>
          </v-chip>

          <br v-if="item.campaign" />


          <span>
             <v-icon x-small>{{ item.hide_flg ? "fa-eye-slash" : "fa-eye" }}</v-icon>
            {{
              $t(settings
                  ? settings.material_name_display_type == 1
                      ? "Material.materialName"
                      : settings.material_name_display_type == 4
                          ? "Material.nameWithCode"
                      : "Material.materialNameWithCode"
                  : "Material.materialName", [item.material_code, item.material_name])
            }}
          </span>
          <br />
          <span class="caption secondary--text">
            {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
            <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
              {{ item.standard_name.slice(0, 12) + "......" }}
            </span>
            <span v-else>
              {{ item.standard_name }}
            </span>
          </span>
        </v-col>
        <v-col cols="4" sm="2" style="margin: auto">
          <span v-if="showPrice" class="ms-1">
            {{ $t("Global.money") }}
            {{
              item.combineFlg
                ? item.price
                : item.count_unit &&
                  item.count_unit_rate &&
                  settings &&
                  settings.count_unit == 1
                ? item.supply_price * item.count_unit_rate
                : item.supply_price | formatMoney
            }}
          </span>
        </v-col>
        <v-col cols="8" sm="4" md="3" style="width: 60px; margin: auto">
          <span v-if="item.combineFlg" class="ms-1">
            {{ $t("MaterialTemplate.Fields.available_quantity")
            }}{{ $t("Global.colon")
            }}<span
              v-if="
                'available_num' in item &&
                (item.available_num != null ||
                  item.available_num != undefined ||
                  item.available_num != 'undefined')
              "
            >
              {{ item.available_num | formatTwoDot }}
            </span>
            <span v-else>
              {{ $t("Order.DetailFields.no_limit") }}
            </span>
          </span>
          <span v-else-if="showAvailableQuantity" class="ms-1">
            {{ $t("MaterialTemplate.Fields.available_quantity")
            }}{{ $t("Global.colon")
            }}<span
              v-if="
                'available_num' in item &&
                (item.available_num != null ||
                  item.available_num != undefined ||
                  item.available_num != 'undefined')
              "
            >
              <span v-if="item.rate > 1">
                {{ item.supply_available_num | formatTwoDot }}
                {{ item.unit }}
              </span>
              <span v-else>
                {{ item.available_num | formatTwoDot }}
                {{ item.default_unit }}
              </span>
            </span>
            <span v-else>
              {{ $t("Order.DetailFields.no_limit") }}
            </span>
          </span>
          <span v-else class="ms-1">
            {{ $t("MaterialTemplate.Fields.stock_quantity")
            }}{{ $t("Global.colon") }}
            <span v-if="item.rate > 1">
              {{ item.current_count_rate_with_unit }}
            </span>
            <span v-else>
              {{ item.current_count | formatTwoDot }}
              {{ item.default_unit }}
            </span>
          </span>
        </v-col>
        <v-col cols="12" class="d-sm-none">
          <v-divider />
        </v-col>
      </v-row>
    </template>
  </v-autocomplete>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import MaterialTemplates from "@/api/material_templates";

export default {
  name: "SearcherTemplateMaterial",

  props: {
    shopId: Number,
    value: Object,
    noLabel: Boolean,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    showPrice: Boolean,
    showAvailableQuantity: Boolean,
  },

  computed: {
    materialsItems() {
      var items = this.combineMaterials.map((combineMaterial) => {
        return Object.assign({}, combineMaterial, {
          Description: combineMaterial.material_name,
          disabled: this.disabledItems
            ? this.disabledItems.find(
                (disabledItem) =>
                  disabledItem.combineFlg &&
                  disabledItem.ruler_id == combineMaterial.id
              )
            : false,
          combineFlg: true,
        });
      });
      this.materials.forEach((material) => {
        const Description =
          i18n.t(
              this.settings.material_name_display_type == 4
              ? "Material.nameWithCodeAndStandard"
              : this.settings.material_name_display_type == 3
              ? "Material.materialNameWithCodeAndStandard"
              : this.settings.material_name_display_type == 2
              ? "Material.materialNameWithCode"
              : "Material.materialName",
            [
              material.material_code,
              material.material_name,
              material.standard_name ? (material.standard_name.length > 12 ? material.standard_name.slice(0, 12) + "......" : material.standard_name) : "",
            ]
          ) + (material.barcode ? "(" + material.barcode + ")" : ""); // 支持多字段搜索商品
        items.push(
          Object.assign({}, material, {
            Description: Description,
            disabled: this.disabledItems
              ? this.disabledItems.find(
                  (disabledItem) =>
                    !disabledItem.combineFlg &&
                    disabledItem.material_id == material.material_id
                )
              : false,
            combineFlg: false,
          })
        );
      });
      return items;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "materialCountMax"]),
  },

  data: () => ({
    materials: [],
    combineMaterials: [],
    materialsLoading: false,
    materialsSearch: "",
    materialsSelected: null,
  }),

  methods: {
    getCombineMaterialsFromAPI(inputType) {
      this.materialsLoading = true;
      if (inputType == "enter") {
        this.$store.dispatch("fullscreenLoading");
      }
      MaterialTemplates.fetchCombineMaterialsByShop(this.shopId).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materials = [];
            this.combineMaterials = response.data.combine_materials;
            this.getMaterialsFromAPI(inputType);
          }
        }.bind(this)
      );
    },
    getMaterialsFromAPI(inputType) {
      var data = {
        keyword: this.materialsSearch,
      };
      if (inputType == "input") {
        data = Object.assign({}, data, { limit: 3 });
      }
      MaterialTemplates.fetchByShop(this.shopId, data)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.materials = response.data.template_details;
              this.$emit("loaded", this.materials);
            }
            this.materialsLoading = false;
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.materialsLoading = false;
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    enterToGetMaterial() {
      if (this.materialsSearch) {
        if (
          typeof this.shopId != "undefined" &&
          this.shopId != null &&
          this.settings.material_count >= this.materialCountMax
        )
          this.getCombineMaterialsFromAPI("enter");
      }
    },
  },

  watch: {
    // 取消延时搜索
    // materialsSearch: {
    //   handler() {
    //     if (
    //       typeof this.shopId != "undefined" &&
    //       this.shopId != null &&
    //       this.settings.material_count >= this.materialCountMax
    //     ) {
    //       clearInterval(this.monitorFocus);
    //       this.monitorFocus = setTimeout(
    //         function () {
    //           if (this.materialsSearch) {
    //             this.getCombineMaterialsFromAPI("input");
    //           }
    //         }.bind(this),
    //         1000
    //       );
    //     }
    //   },
    // },
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.materialsSelected = this.value;
        // if (this.settings.material_count >= this.materialCountMax) {
        //   this.$emit("loaded", this.materials);
        // }
      },
    },
    materialsSelected: {
      handler() {
        if (this.materialsSelected) this.$emit("input", this.materialsSelected);
      },
    },
    shopId: {
      immediate: true, //初始赋值也调用
      handler() {
        if (
          typeof this.shopId != "undefined" &&
          this.shopId != null &&
          this.settings.material_count < this.materialCountMax
        )
          this.getCombineMaterialsFromAPI();
      },
    },
  },
};
</script>
